<template>
  <v-container fluid style="padding: 0; min-height: 100vh">
    <v-row no-gutters>
      <v-col cols="12">
        <GlobalNav />
      </v-col>

      <v-col cols="12" class="publish-post-view">
        <div class="publish-post-contain d-flex flex-column flex-md-row h-100">
          <SideBar />

          <div class="publish-post">
            <BreadCrumb :linksData="linksData" class="mb-5" />

            <div class="create-review-post">
              <v-row class="create-post-page">
                <v-col cols="12">
                  <v-row align="center" justify="space-between">
                    <v-col cols="auto">
                      <h2 class="post-title">Create New Post</h2>
                    </v-col>

                    <v-col cols="auto" class="d-flex align-center">
                      <span class="filter-label mr-2">Filter by size</span>

                      <v-btn-toggle
                        v-model="viewType"
                        dense
                        class="view-toggle"
                        mandatory
                      >
                        <v-btn
                          value="grid"
                          class="view-btn"
                          :class="{ active: viewType === 'grid' }"
                        >
                          <v-icon>mdi-view-grid</v-icon>
                        </v-btn>
                        <v-btn
                          value="list"
                          class="view-btn"
                          :class="{ active: viewType === 'list' }"
                        >
                          <v-icon>mdi-cellphone</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                  </v-row>
                </v-col>
                <!--start platform-selectors-row-->
                <v-col cols="12">
                  <v-row class="platform-selectors-row" dense>
                    <PlatformChannelSelect />
                  </v-row>
                </v-col>
                <!--end platform-selectors-row-->
              </v-row>

              <div class="review-post">
                <NewReview />
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import NewReview from "@/components/publish_post_components/NewReview.vue";
import PlatformChannelSelect from "@/components/Newpublish/PlatformChannelSelect.vue";

export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    NewReview,
    PlatformChannelSelect,
  },
  data() {
    return {
      viewType: "grid",
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Publish Post", link: "" },
      ],
      selectedPlatforms: {
        facebook: 2,
        instagram: 2,
      },
      platforms: [
        {
          name: "facebook",
          icon: require("@/assets/images/icons/facebook.svg"),
          count: 2,
          defaultType: ["Post"],
        },
        {
          name: "instagram",
          icon: require("@/assets/images/icons/facebook.svg"),
          count: 2,
          defaultType: ["Reel"],
        },
        {
          name: "x",
          icon: require("@/assets/images/icons/facebook.svg"),
          count: 2,
          defaultType: ["Post"],
        },
        {
          name: "tiktok",
          icon: require("@/assets/images/icons/facebook.svg"),
          count: 2,
          defaultType: ["Story"],
        },
      ],
    };
  },
  methods: {
    handlePlatformSelection(platformName) {
      console.log("Platform selected:", platformName);
    },
    handleTypeChange({ platform, types }) {
      console.log(`Changed ${platform} to:`, types);
    },
  },
};
</script>

<style scoped>
.create-post-page {
  background-color: #fff;
  width: 100%;
}

.post-title {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 0;
}

.filter-label {
  color: #16777a;
  font-weight: 500;
}

.view-toggle {
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}

.view-btn {
  min-width: 36px;
  height: 36px;
  color: #16777a;
  background-color: transparent;
  transition: all 0.2s ease;
  padding: 0;
}

.view-btn.active {
  background-color: #16777a;
  color: white;
}
</style>
